import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface Props {
  isOpen: boolean;
  onClose(): void;
  onConfirmation(): void;
}

export const ClearMetricsConfirmationModal = ({
  isOpen,
  onClose,
  onConfirmation,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleContent={
        <div className="font-semibold text-[1.5rem]">Clear Metrics</div>
      }
    >
      <div className="flex items-center justify-end gap-2 mt-6">
        <TertiaryButton className="font-bold" onClick={() => onClose()}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          className="font-bold flex items-center gap-2 bg-mars hover:bg-mars+1"
          onClick={() => onConfirmation()}
        >
          CLEAR
        </PrimaryButton>
      </div>
    </Modal>
  );
};
